import api from '@/services/api.js';

export default {
  namespaced: true,
  state: {
    gruposContables: [],
    ubicaciones: [],
    parametrosCargados: false,
    ubicacionesCargadas: false
  },
  mutations: {
    SET_PARAMETROS(state, data) {
      state.gruposContables = data.grupos || [];
      state.ubicaciones = data.ubicaciones || [];
      state.parametrosCargados = true;
      state.ubicacionesCargadas = true;
    },
    SET_UBICACIONES(state, data) {
      state.ubicaciones = data || [];
      state.ubicacionesCargadas = true;
    }
  },
  actions: {
    async fetchParametrosIniciales({ commit, state }) {
      if (state.parametrosCargados) return;
      try {
        const { data } = await api.get('activos/parametros_iniciales/');
        commit('SET_PARAMETROS', data);
      } catch (error) {
        console.error('Error fetching parametros iniciales:', error);
      }
    },
    async fetchUbicaciones({ commit, state }) {
      if (state.ubicacionesCargadas) return;
      try {
        const { data } = await api.get('activos/ubicaciones_list/');
        commit('SET_UBICACIONES', data);
      } catch (error) {
        console.error('Error fetching ubicaciones:', error);
      }
    }
  }
};
